import { Component, inject } from '@angular/core';
import { LoadPropertyService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LoadPropertyCreateDto,
  LoadPropertyDto,
  LoadPropertyExcelDownloadDto,
  LoadPropertyUpdateDto,
} from '../proxy/planning/dtos/load-property';
import { LOADPROPERTY_CONFIG, LOADPROPERTY_FIELDS } from './load-property.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-load-property',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LoadPropertyService, ConfirmationService],
  templateUrl: './load-property.html',
  styleUrl: './load-property.scss',
})
export class LoadProperty extends BaseHierarchicalCrudComponent<
  LoadPropertyDto,
  LoadPropertyCreateDto,
  LoadPropertyUpdateDto,
  LoadPropertyExcelDownloadDto
> {
  service = inject(LoadPropertyService);
  config = LOADPROPERTY_CONFIG;
  fields = LOADPROPERTY_FIELDS;

  protected prepareUpdateDto(data: any, selected: LoadPropertyDto): LoadPropertyUpdateDto {
    return {
      locationId: data.locationId,
      departmentId: data.departmentId,
      localCorridorId: data.localCorridorId,
      propertyId: data.propertyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LoadProperty';
  }
}
